module.exports = __webpack_public_path__ + "static/img/tiao@2x.1ff11af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commission/tiao@2x.png
// module id = hOvD
// module chunks = 70